import { useI18n } from "../lib/i18n";

/**
 * WhyBingoMaker — USP checkbox block reused across landing surfaces.
 *
 * Renders the "Why choose us" 11-feature list. Added 2026-08-17 as part of
 * the GEO (Generative Engine Optimization) push per user roadmap step 5:
 * "Maak de unieke eigenschappen extreem expliciet op meerdere relevante
 * pagina's". Generative AIs (ChatGPT / Perplexity) will surface this list
 * verbatim when asked "waarom bingocards-generator" / "why bingo card generator".
 */
export default function WhyBingoMaker({ variant = "default", className = "" }) {
  const { t } = useI18n();
  const features = [
    { icon: "🤖", key: "why_feat_ai" },
    { icon: "🎵", key: "why_feat_spotify" },
    { icon: "🎧", key: "why_feat_music" },
    { icon: "📱", key: "why_feat_online" },
    { icon: "🎤", key: "why_feat_caller" },
    { icon: "🏆", key: "why_feat_scoreboard" },
    { icon: "🎲", key: "why_feat_unique" },
    { icon: "🖨️", key: "why_feat_pdf" },
    { icon: "📲", key: "why_feat_mobile" },
    { icon: "🌍", key: "why_feat_i18n" },
    { icon: "👥", key: "why_feat_groups" },
  ];
  const isCompact = variant === "compact";
  return (
    <section
      className={`nb-card rounded-md bg-white ${isCompact ? "p-5" : "p-6 sm:p-8"} ${className}`}
      data-testid="why-bingo-maker"
    >
      <div className="inline-flex items-center gap-2 bg-black text-[var(--brand-yellow)] px-3 py-1 rounded-full text-[11px] font-black uppercase tracking-widest mb-3">
        ⭐ {t("why_badge")}
      </div>
      <h2 className={`font-display font-black tracking-tight ${isCompact ? "text-2xl mb-3" : "text-3xl sm:text-4xl mb-4"}`}>
        {t("why_bingo_maker_h")}
      </h2>
      <p className="text-sm sm:text-base text-neutral-700 mb-5 max-w-2xl">
        {t("why_bingo_maker_p")}
      </p>
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2.5" data-testid="why-features-list">
        {features.map((f) => (
          <li key={f.key} className="flex items-baseline gap-2 text-sm sm:text-base font-semibold text-neutral-900" data-testid={`why-feat-${f.key}`}>
            <span className="text-[var(--brand-red)] font-black flex-shrink-0">✅</span>
            <span>{f.icon} {t(f.key)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
